'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  baseline: 'baseline'
};


//////////////////
// WEBPACK FOOTER
// ./~/flexomatic/lib/utils/align.js
// module id = 801
// module chunks = 4